import React, { useState } from "react";
import { Principal } from "@dfinity/agent";
import ContentContainer from "@origyn-sa/common-ui/src/components/atoms/ContentContainer";
import Button from "@origyn-sa/common-ui/src/components/atoms/Button";
import InputField from "@origyn-sa/common-ui/src/components/molecules/InputField";
import PageTitle from "@origyn-sa/common-ui/src/components/atoms/PageTitle";
import { client } from "../../agent";
import { LinearProgress } from "@material-ui/core";
import { handleError } from "../../utils";

const MarketplaceSetup = () => {
  const [loader, setLoader] = useState<boolean>(false);
  const handleSubmit = (e: any) => {
    setLoader(true);
    e.preventDefault();
    const formData = new FormData(e.target);
    const object: { [key: string]: any } = {};
    formData.forEach((value, key) => {
      object[key] = value;
    });
    client.actor
      .initialize(Principal.fromText(object.admin), object.name)
      .then((response: any) => {
        window.location.href = "/";
      })
      .catch((err: any) => handleError)
      .finally(() => setLoader(false));
  };

  return (
    <ContentContainer centered>
      {loader && (
        <LinearProgress
          style={{ position: "fixed", top: 0, left: 0, width: "100%" }}
        />
      )}
      <PageTitle align='center'>Marketplace Setup</PageTitle>
      <ContentContainer spacing={1.5} small centered>
        <form onSubmit={handleSubmit}>
          <InputField
            label='Administrator'
            defaultValue={localStorage.getItem("principal") || ""}
            name='admin'
            placeholder='(PrincipalID)'
          />
          <InputField label='Name' name='name' placeholder='ex. WatchSwap' />
          <InputField
            label='Description'
            name='description'
            placeholder='My awesome shop'
          />
          <Button type='submit'>Setup</Button>
        </form>
      </ContentContainer>
    </ContentContainer>
  );
};

export default MarketplaceSetup;
